import React from 'react'

import App from '../App.css'
import OneMapLogoFooter from '../images/OM2_LOGO_white.png'
import { handleEvtClicks } from '../js/helper'

const FooterComponent = () => {
  return (
    <>
    <div className="om-body-footer">
        <div className="pageBase">
          <div className="om-container-fluid-padding">
            <div className='om-footer container-fluid'>
              <div className='om-footer-row om-footer-row-top d-flex justify-content-between align-items-center'>
                <div className='row'>
                  <ul className="nav">
                    <li className="nav-item" >
                      <a className="nav-link" href={`${process.env.REACT_APP_PUBLIC_URL}/register`} onClick={()=>{new handleEvtClicks('click', {select: 'Register'})}}>Register</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href={`${process.env.REACT_APP_PUBLIC_URL}/apidocs`} onClick={()=>{new handleEvtClicks('click', {select: 'APIDocs'})}}>API Documentation</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href='https://www.onemap.gov.sg/legal/apitermsofservice.html' onClick={()=>{new handleEvtClicks('click', {select: 'TOS'})}}>API Terms of Use</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href='https://www.onemap.gov.sg/legal/opendatalicence.html' onClick={()=>{new handleEvtClicks('click', {select: 'OpenData'})}}>Singapore Open Data License</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href={`${process.env.REACT_APP_PUBLIC_URL}/contactus`} onClick={()=>{new handleEvtClicks('click', {select: 'ContactUs'})}}>Contact Us</a>
                    </li>
                  </ul>
                </div>
                <div className='om-footer-icon justify-content-end px-3'>
                  <a href={`${process.env.REACT_APP_PUBLIC_URL}/`}>
                    <img src={OneMapLogoFooter} alt="OneMap Singapore" />
                  </a>
                </div>
              </div>

              <hr className="om-footer-seperator" />

              <div className='om-footer-row om-footer-row-top d-flex justify-content-between align-items-center'>
                <div className='row'>
                  <ul className="nav">
                    <li className="nav-item">
                      <a className="nav-link" href='https://www.sla.gov.sg/' target='_blank' rel='noopener noreferrer'
                      onClick={()=>{new handleEvtClicks('click', {select: 'SLA'})}}>Singapore Land Authority</a>
                    </li>
                  </ul>
                </div>
                <div className='om-footer-attribution justify-content-end px-3'>
                    ©2025 OneMap. All rights reserved
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default FooterComponent
